import { render, staticRenderFns } from "./ProductInventoryFormModel.vue?vue&type=template&id=683f4cdc&"
import script from "./ProductInventoryFormModel.vue?vue&type=script&lang=ts&"
export * from "./ProductInventoryFormModel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports